import { documentThemePreferenceStore } from '@words-happen/theme-preference';
import { WordsHappenThemeProvider } from '@words-happen/ui-components';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import Application from './application';
import { redirectToCanonicalHost } from './navigation';
import '@words-happen/ui-components/ui-components.css';
import css from './main.module.scss';

const themePreference = documentThemePreferenceStore(SESSION_COOKIE_DOMAIN);

// On any other host (*.pages.dev, *.firebaseapp.com, *.web.app), go to id.<domain> before rendering.
if (!redirectToCanonicalHost(window.location, REDIRECT_TO_IDENTITY_URL, IDENTITY_URL)) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Router>
        <WordsHappenThemeProvider store={themePreference} className={css.main}>
          <Application />
        </WordsHappenThemeProvider>
      </Router>
    </React.StrictMode>,
  );
}
